/**
 * DevAuthBypassBanner — subtle warning strip rendered when the build is
 * using VITE_AUTH_BYPASS=true.
 *
 * V0.5.0 Q6 (locked decision): we keep the dev-bypass affordance so
 * developers don't need to spin up a Cognito pool to run locally, but
 * we make it visually obvious so nobody screenshots a prod-looking app
 * from a bypass dev env and mistakes it for the real thing.
 *
 * The banner is small (24px), uses amber to differentiate from any
 * brand color, and never renders in non-bypass builds (returns null).
 */
import { useAuth } from "./AuthContext";

export function DevAuthBypassBanner() {
  const { bypass } = useAuth();
  if (!bypass) return null;
  return (
    <div className="bg-amber-100 px-4 py-1 text-center text-xs font-medium text-amber-700">
      <span className="font-semibold">DEV ·</span> auth bypass is active — every request sends a
      static <code className="bg-amber-50 px-1 rounded">dev-bypass-token</code> bearer.
      Real Cognito login is disabled.
    </div>
  );
}
